import React, { FC } from 'react';
import Icon, { Icons, IconType } from '../../atoms/Icon';
import { PictureProps } from '../../atoms/Picture';
import * as SC from './styled';
export type CheeseTrait = {
  icon: IconType;
  label: string;
};
export type CheeseBestWithEntry = {
  icon: IconType;
  title: string;
  text: string;
};
export type CheeseMainContentProps = {
  className?: string;
  traits?: CheeseTrait[];
  characterTitle?: string;
  characterText?: string;
  characterImage?: PictureProps;
  didYouKnowTitle?: string;
  didYouKnowText?: string;
  originTitle?: string;
  originText?: string;
  originImage?: PictureProps;
  tastingTitle?: string;
  tastingText?: string;
  bestWithTitle?: string;
  bestWithEntries?: CheeseBestWithEntry[];
  healthTitle?: string;
  healthText?: string;
};
const CheeseMainContent: FC<CheeseMainContentProps> = ({
  className,
  traits,
  characterTitle,
  characterText,
  characterImage,
  didYouKnowTitle,
  didYouKnowText,
  originTitle,
  originText,
  originImage,
  healthTitle,
  healthText,
  tastingTitle,
  tastingText,
  bestWithTitle,
  bestWithEntries
}) => {
  return <SC.Container className={className}>
      <SC.Traits>
        {traits?.map((trait, i) => <SC.Trait key={i}>
            <Icon icon={trait.icon} />
            <span>{trait.label}</span>
          </SC.Trait>)}
      </SC.Traits>
      <SC.Sections>
        {(characterTitle || characterText) && <SC.Section>
            <SC.SectionWrapper>
              <SC.SectionTitle>{characterTitle}</SC.SectionTitle>
              <SC.Image {...characterImage} />
              <SC.SectionText>{characterText}</SC.SectionText>
            </SC.SectionWrapper>
            {characterImage && <SC.Image {...characterImage} />}
          </SC.Section>}
        {(didYouKnowTitle || didYouKnowText) && <SC.DidYouKnow>
            <SC.StyledIcon icon={Icons.sherlock} />
            <div>
              <SC.DidYouKnowTitle>{didYouKnowTitle}</SC.DidYouKnowTitle>
              <SC.DidYouKnowText>{didYouKnowText}</SC.DidYouKnowText>
            </div>
          </SC.DidYouKnow>}
        {(originTitle || originText) && <SC.Section>
            <SC.SectionWrapper>
              <SC.SectionTitle>{originTitle}</SC.SectionTitle>
              <SC.Image {...originImage} $hasBorder />
              <SC.SectionText>{originText}</SC.SectionText>
            </SC.SectionWrapper>
            {originImage && <SC.Image {...originImage} $hasBorder />}
          </SC.Section>}
        {healthTitle && healthText && <SC.Section>
            <SC.SectionWrapper>
              <SC.SectionTitle>{healthTitle}</SC.SectionTitle>
              <SC.SectionText>{healthText}</SC.SectionText>
            </SC.SectionWrapper>
          </SC.Section>}
        {(tastingTitle || tastingText || bestWithEntries && bestWithEntries.length > 0) && <SC.Section>
            <SC.SectionWrapper>
              <SC.SectionTitle>{tastingTitle}</SC.SectionTitle>
              <SC.SectionText>{tastingText}</SC.SectionText>
            </SC.SectionWrapper>
            {bestWithEntries && bestWithEntries.length > 0 && <SC.BestWith>
                <SC.BestWithTitle>{bestWithTitle}</SC.BestWithTitle>
                {bestWithEntries?.map((entry, i) => <SC.BestWithEntry key={i}>
                    <SC.StyledIcon icon={entry.icon} />
                    <div>
                      <SC.BestWithEntryTitle>
                        {entry.title}
                      </SC.BestWithEntryTitle>
                      <SC.BestWithEntryText>{entry.text}</SC.BestWithEntryText>
                    </div>
                  </SC.BestWithEntry>)}
              </SC.BestWith>}
          </SC.Section>}
      </SC.Sections>
    </SC.Container>;
};
export default CheeseMainContent;